
import React, { useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, ButtonGroup, IconButton, Checkbox } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { CODES } from "../../../utils/responseCodes";
import { Toast } from "../../../utils/alerts";
import MofService from "../../../services/mof";
import LinearProgress from '@mui/material/LinearProgress';
import Inventory2IconTwoToneIcon from '@mui/icons-material/Inventory2TwoTone';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Swal from "sweetalert2";


const columns = [
  { id: "select", label: "", minWidth: 50, align: "left" },
  { id: "", label: "#", minWidth: 50, align: "left" },
  { id: "codMof", label: "Codigo", minWidth: 150, align: "left" },
  { id: "cliente.empresa.desEmpresa", label: "Empresa", minWidth: 200, align: "left" },
  { id: "cliente.desCliente", label: "Cliente", minWidth: 200, align: "left" },
  { id: "puesto.desPuesto", label: "Puesto", minWidth: 200, align: "left" },
  { id: "desEstado", label: "Estado", minWidth: 50, align: "left" },
  { id: "porcentaje", label: "Porcentaje", minWidth: 150, align: "left" },
  { id: "trabajador", label: "Ult. Modifiación", minWidth: 200, align: "left" },
  { id: "actions", label: "Acciones", minWidth: 120, align: "center" },
];


const BodyMof = (props) => {
  const { handleOpen, setOpenModalLoader, listaMof, setListaMof, listarMof, getDatosMof, setPuestoId,
    setCompanieId, setClienteId, setMofId, setOpcionVer, setType, getAprobado, idUsuario, usuaruioEditor, selectedMofs, setSelectedMofs } = props;
  
  const url = "'" + window.location.hash.replace("#", "") + "'";

  const eliminarMof = async (id_mof) => {
    try {
      const result = await Toast.fire({
        icon: 'question',
        title: '¿Estás seguro que deseas eliminar este MOF?',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: 'Sí',
        cancelButtonText: 'No',
      });

      if (result.isConfirmed) {
        setOpenModalLoader(true);
        try {
          const result = await MofService.eliminarMof(id_mof);
          if (result.status === CODES.SUCCESS_200) {
            Toast.fire({
              icon: 'success',
              title: result.data.message || 'MOF Eliminado'
            });
            setListaMof(result.data.listaMof);
            listarMof();
          } else {
            Toast.fire({
              icon: 'error',
              title: (result?.response?.data?.message || 'Error, no se eliminó el MOF')
            });
          }
          return [];
        } catch (error) {
          console.log(`Error en eliminarMof: ${error}`);
        } finally {
          setOpenModalLoader(false);

        }
      } else {
        // El usuario canceló la eliminación
        Toast.fire({
          icon: 'info',
          title: 'La eliminación del MOF ha sido cancelada.'
        });
      }
    } catch (error) {
      console.log(`Error en eliminarMof: ${error}`);
    }
  };

  const getProgressColor = (percentage) => {
    if (percentage <= 30) {
      return "error";
    } else if (percentage >= 31 && percentage <= 80) {
      return "warning";
    } else {
      return "success";
    }
  };

  const archivarMof = async (id_mof, archivado) => {
    try {
      const result = await Toast.fire({
        icon: 'question',
        title: archivado === 1
          ? '¿Estás seguro que deseas archivar este MOF?'
          : '¿Estás seguro que deseas desarchivar este MOF?',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: 'Sí',
        cancelButtonText: 'No',
      });

      if (result.isConfirmed) {
        setOpenModalLoader(true);
        try {
          const result = await MofService.archivarMof(id_mof, archivado);

          if (result.status === CODES.SUCCESS_200) {
            Toast.fire({
              icon: 'success',
              title: result.data.message || 'MOF actualizado'
            });
            setListaMof(result.data.listaMof); // si estás usando esto
            listarMof(); // recarga la tabla
          } else {
            Toast.fire({
              icon: 'error',
              title: result?.response?.data?.message || 'Error, no se actualizó el MOF'
            });
          }
        } catch (error) {
          console.log(`Error en archivarMof: ${error}`);
        } finally {
          setOpenModalLoader(false);
        }
      } else {
        Toast.fire({
          icon: 'info',
          title: 'Acción cancelada'
        });
      }
    } catch (error) {
      console.log(`Error en archivarMof: ${error}`);
    }
  };

  const handleCheckboxChange = (mof, checked) => {
    if (checked) {
      setSelectedMofs(prev => [...prev, mof]);
    } else {
      setSelectedMofs(prev => prev.filter(item => item.id_mof !== mof.id_mof));
    }
  };
  const duplicarMof = async (id) => {
    try {
  
      const { data } = await MofService.duplicarMof(id);
  
      const nuevoCodigo = data.nuevo_codigo;
  
      Swal.fire({
        icon: 'success',
        title: 'MOF duplicado correctamente',
        html: `
          <div style="margin-top:10px;">
            <strong>Código generado:</strong>
            <div style="
                margin-top:8px;
                padding:10px;
                background:#f4f4f4;
                border-radius:6px;
                font-family:monospace;
                user-select:all;
            ">
              ${nuevoCodigo}
            </div>
            <button id="copiarCodigo" 
                style="
                  margin-top:10px;
                  padding:6px 12px;
                  background:#3085d6;
                  color:white;
                  border:none;
                  border-radius:4px;
                  cursor:pointer;
                ">
                Copiar código
            </button>
          </div>
        `,
        showConfirmButton: false,
        didOpen: () => {
          const btn = document.getElementById('copiarCodigo');
          btn.addEventListener('click', async () => {
            await navigator.clipboard.writeText(nuevoCodigo);
            Swal.close(); // 🔥 se cierra automáticamente
          });
        }
      });
      
  
      listarMof();
  
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error al duplicar'
      });
    }
  };
  
  

  // if (idPerfil === 16 || idPerfil === 1 || idPerfil === 23 || usuaruioEditor?.some(user => +user?.usuario_id === idUsuario)) {
  if (usuaruioEditor?.some(user => +user?.usuario_id === idUsuario)) {
    return (
      <div className="page-body-main">
        <div className="page-body__table" style={{ overflow: "hidden" }}>
          <div className="page-body-table">
            <TableContainer className="table-height">
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                        {column.id === "select" ? (
                          <Checkbox
                            title="Seleccionar/Deseleccionar hasta 10"
                            checked={
                              listaMof?.slice(0, 10).every(row =>
                                selectedMofs.some(sel => sel.id_mof === row.id_mof)
                              )
                            }
                            indeterminate={
                              selectedMofs.length > 0 &&
                              listaMof.slice(0, 10).some(row =>
                                selectedMofs.some(sel => sel.id_mof === row.id_mof)
                              ) &&
                              !listaMof.slice(0, 10).every(row =>
                                selectedMofs.some(sel => sel.id_mof === row.id_mof)
                              )
                            }
                            onChange={(e) => {
                              const checked = e.target.checked;
                              if (checked) {
                                // Agrega hasta 10
                                const nuevos = listaMof.slice(0, 10).filter(
                                  (row) => !selectedMofs.some(sel => sel.id_mof === row.id_mof)
                                );
                                if (selectedMofs.length + nuevos.length <= 10) {
                                  setSelectedMofs([...selectedMofs, ...nuevos]);
                                } else {
                                  Toast.fire({
                                    icon: "warning",
                                    title: "Solo puedes seleccionar hasta 10 MOFs.",
                                  });
                                }
                              } else {
                                // Quita los seleccionados entre los primeros 10
                                const nuevos = selectedMofs.filter(
                                  sel => !listaMof.slice(0, 10).some(row => row.id_mof === sel.id_mof)
                                );
                                setSelectedMofs(nuevos);
                              }
                            }}
                          />
                        ) : column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {listaMof?.map((record, indexRow) => (
                    <TableRow hover role="checkbox" tabIndex={-1} key={"row" + indexRow}>
                      {columns.map((column, indexColumn) => (
                        <TableCell key={"col" + indexColumn} align={column.align}>
                          {column.id === "select" ? (
                            <Checkbox
                              checked={selectedMofs.some(item => item.id_mof === record.id_mof)}
                              onChange={(e) => {
                                const checked = e.target.checked;
                                setSelectedMofs((prevSelected) => {
                                  if (checked) {
                                    if (prevSelected.length >= 10) {
                                      Toast.fire({
                                        icon: "warning",
                                        title: "Solo puedes seleccionar 10 mof",
                                      });
                                      return prevSelected; // No se agrega más
                                    }
                                    return [...prevSelected, record];
                                  } else {
                                    return prevSelected.filter((item) => item.id_mof !== record.id_mof);
                                  }
                                });
                              }}
                              size="small"
                              title="Seleccionar para exportar"
                            />
                          ) : column.id === "" ? (
                            indexRow + 1
                          ) :
                            column.id === "porcentaje" ? (
                              <div style={{ width: '100%' }}>
                                <LinearProgress
                                  variant="determinate"
                                  value={Number(record?.porcentaje)}
                                  color={getProgressColor(Number(record?.porcentaje))}
                                  style={{ height: 8 }}
                                />
                                <span style={{ marginLeft: 10 }}>{Number(record?.porcentaje).toFixed(2)}%</span>
                              </div>
                            ) :
                              column.id === "" ? indexRow + 1 :
                                column.id === "desEstado" ?
                                  <span style={{ color: record.desEstado === 'derivado' ? 'red' : record.desEstado === 'terminado' ? 'green' : 'inherit' }}>
                                    {eval(`record.${column.id}`)}
                                  </span>
                                  :
                                  column.id === "actions" ?
                                    <ButtonGroup disableElevation variant="contained" aria-label="Disabled elevation buttons">
                                      <IconButton size="small" title="Ver Mof"
                                        onClick={() => {

                                          getAprobado(record.id_mof)
                                          setPuestoId(record.puesto_id);
                                          setCompanieId(record.cliente.empresa_id);
                                          setClienteId(record.cliente_id);
                                          setMofId(record.id_mof);
                                          handleOpen();
                                          setOpcionVer(5); setType(1);
                                          getDatosMof(record.id_mof);
                                        }}
                                      >
                                        <VisibilityIcon color="info" fontSize="small" />
                                      </IconButton>
                                      <IconButton
                                        aria-label="delete"
                                        size="small"
                                        onClick={() => {
                                          getDatosMof(record.id_mof);
                                          getAprobado(record.id_mof)
                                          setPuestoId(record.puesto_id);
                                          setCompanieId(record.cliente.empresa_id);
                                          setClienteId(record.cliente_id);
                                          setMofId(record.id_mof);
                                          handleOpen();
                                          setOpcionVer(6);
                                          setType(1);
                                        }}
                                        title="Editar Mof"
                                      >
                                        <EditIcon color="warning" fontSize="small" />
                                      </IconButton>
                                      <IconButton
                                        size="small"
                                        title={+record.archivado == 1 ? 'Desarchivar Mof' : 'Archivar Mof'}
                                        onClick={() => {
                                          archivarMof(record.id_mof, +record.archivado == 1 ? 0 : 1);
                                        }}
                                      >
                                        <Inventory2IconTwoToneIcon
                                          style={{ color: +record.archivado == 1 ? 'orange' : 'gray' }}
                                          fontSize="small"
                                        />
                                        </IconButton>
                                        <IconButton
                                          size="small"
                                          title="Duplicar Mof"
                                          onClick={() => duplicarMof(record.id_mof)}
                                        >
                                          <ContentCopyIcon color="primary" fontSize="small" />
                                        </IconButton>
                                        <IconButton size="small" title="Eliminar Mof"
                                          onClick={() => {
                                          eliminarMof(record.id_mof)
                                        }}
                                      >
                                        <DeleteForeverIcon color="error" fontSize="small" />
                                      </IconButton>

                                    </ButtonGroup>
                                    : eval(`record.${column.id}`)}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="page-body-main">
        <div className="page-body__table" style={{ overflow: "hidden" }}>
          <div className="page-body-table">
            <TableContainer className="table-height">
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                        {column.id === "select" ? (
                          <Checkbox
                            title="Seleccionar/Deseleccionar hasta 10"
                            checked={
                              listaMof?.slice(0, 10).every(row =>
                                selectedMofs.some(sel => sel.id_mof === row.id_mof)
                              )
                            }
                            indeterminate={
                              selectedMofs.length > 0 &&
                              listaMof.slice(0, 10).some(row =>
                                selectedMofs.some(sel => sel.id_mof === row.id_mof)
                              ) &&
                              !listaMof.slice(0, 10).every(row =>
                                selectedMofs.some(sel => sel.id_mof === row.id_mof)
                              )
                            }
                            onChange={(e) => {
                              const checked = e.target.checked;
                              if (checked) {
                                // Agrega hasta 10
                                const nuevos = listaMof.slice(0, 10).filter(
                                  (row) => !selectedMofs.some(sel => sel.id_mof === row.id_mof)
                                );
                                if (selectedMofs.length + nuevos.length <= 10) {
                                  setSelectedMofs([...selectedMofs, ...nuevos]);
                                } else {
                                  Toast.fire({
                                    icon: "warning",
                                    title: "Solo puedes seleccionar hasta 10 MOFs.",
                                  });
                                }
                              } else {
                                // Quita los seleccionados entre los primeros 10
                                const nuevos = selectedMofs.filter(
                                  sel => !listaMof.slice(0, 10).some(row => row.id_mof === sel.id_mof)
                                );
                                setSelectedMofs(nuevos);
                              }
                            }}
                          />
                        ) : column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {/* Mapear los elementos de mofxUsuario y mostrar los valores en la tabla */}
                  {listaMof && listaMof.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell key={"col" + index}>
                        <Checkbox
                          checked={selectedMofs.some(item => item.id_mof === row.id_mof)}
                          onChange={(e) => {
                            const checked = e.target.checked;
                            setSelectedMofs((prevSelected) => {
                              if (checked) {
                                if (prevSelected.length >= 10) {
                                  Toast.fire({
                                    icon: "warning",
                                    title: "Solo puedes seleccionar 10 mof",
                                  });
                                  return prevSelected; // No se agrega más
                                }
                                return [...prevSelected, row];
                              } else {
                                return prevSelected.filter((item) => item.id_mof !== row.id_mof);
                              }
                            });
                          }}
                          size="small"
                          title="Seleccionar para exportar"
                        />
                      </TableCell>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{row.codMof}</TableCell>
                      <TableCell>{row.cliente.empresa.desEmpresa}</TableCell>
                      <TableCell>{row.cliente.desCliente}</TableCell>
                      <TableCell>{row.puesto.desPuesto}</TableCell>
                      <TableCell style={{ color: row.desEstado === 'Proceso' ? 'red' : row.desEstado === 'Terminado' ? 'green' : 'inherit' }}>
                        {row.desEstado}
                      </TableCell>
                      <TableCell>
                        <div style={{ width: '100%' }}>
                          <LinearProgress
                            variant="determinate"
                            value={Number(row?.porcentaje)}
                            color={getProgressColor(Number(row?.porcentaje))}
                            style={{ height: 8 }}
                          />
                          <span style={{ marginLeft: 10 }}>{Number(row?.porcentaje).toFixed(2)}%</span>
                        </div>
                      </TableCell>
                      <TableCell>{row.trabajador}</TableCell>
                      <TableCell>
                        <ButtonGroup disableElevation variant="contained" aria-label="Disabled elevation buttons">
                          {+row.permiso_id === 1 && (
                            <>
                              <IconButton size="small" title="Ver Mof"
                                onClick={() => {

                                  setPuestoId(row.puesto_id);
                                  setCompanieId(row.cliente.empresa_id);
                                  setClienteId(row.cliente_id);
                                  setMofId(row.id_mof);
                                  handleOpen();
                                  setOpcionVer(5);
                                  getDatosMof(row.id_mof); setType(1);
                                }}
                              >
                                <VisibilityIcon color="info" fontSize="small" />
                              </IconButton>
                            </>
                          )}

                          {+row.permiso_id === 2 && (
                            <>
                              <IconButton size="small" title="Ver Mof"
                                onClick={() => {

                                  setPuestoId(row.puesto_id);
                                  setCompanieId(row.cliente.empresa_id);
                                  setClienteId(row.cliente_id);
                                  setMofId(row.id_mof);
                                  handleOpen();
                                  setOpcionVer(5);
                                  getDatosMof(row.id_mof); setType(1);
                                }}
                              >
                                <VisibilityIcon color="info" fontSize="small" />
                              </IconButton>
                              <IconButton size="small" title="Editar Mof"
                                onClick={() => {
                                  setPuestoId(row.puesto_id);
                                  setCompanieId(row.cliente.empresa_id);
                                  setClienteId(row.cliente_id);
                                  setMofId(row.id_mof);
                                  handleOpen();
                                  setOpcionVer(6)
                                  getDatosMof(row.id_mof);
                                }}

                              >
                                <EditIcon color="warning" fontSize="small" />
                              </IconButton>
                              <IconButton size="small" title="Archivar Mof"
                                onClick={() => {
                                  archivarMof(row.id_mof)
                                }}
                              >
                                <Inventory2IconTwoToneIcon color="gray" fontSize="small" />
                              </IconButton>
                            </>
                          )}
                        </ButtonGroup>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      </div>
    );
  }

};


export default BodyMof;
